import React, { Component } from 'react';
import './pages.css';

import Button from './button.js';

require('./Fonts/691970/0a9b9cc6-55eb-4369-97ed-87b3eefd433a.woff2');
require('./Fonts/691979/84e1d9b2-4a5e-42f7-b7bb-e9edadb46977.woff2');

const image1 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522862/uxui/ui1_avvl2l.png';
const image2 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522862/uxui/ui2_tqp121.png';
const image3 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522863/uxui/ui3_nf3r6y.png';
const image4 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522862/uxui/ui4_ldjlct.png';
const image5 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522862/uxui/ui5_sddnih.png';
const image6 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522861/uxui/ui6_umsyz3.png';
const image7 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522861/uxui/ui7_aee2br.png';
const image8 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522862/uxui/ui8_npczfa.png';
const image9 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522861/uxui/ui9_vop1ni.png';

const allExpandableImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
];

let nextImage, prevImage, clearImage;

const handleKeyDown = (e) => {
    const key = e.keyCode;
    const escape = 27;
    const leftArrow = 37;
    const rightArrow = 39;

    if (key === escape) {
        clearImage && clearImage();
        e.stopPropagation();
        e.preventDefault();
    } else if (key === rightArrow) {
        nextImage && nextImage();
        e.stopPropagation();
        e.preventDefault();
    } else if (key === leftArrow) {
        prevImage && prevImage();
        e.stopPropagation();
        e.preventDefault();
    }
};

class UXUIPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
        imageToShow: undefined
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', handleKeyDown);
  }

  render() {
    const { changePage } = this.props;
    const { imageToShow } = this.state;
    const setImage = (image) => {
        this.setState({ imageToShow: image });
    };

    nextImage = () => {
        if (!!imageToShow) {
            const index = allExpandableImages.indexOf(imageToShow);
            setImage(allExpandableImages[(index + 1) % allExpandableImages.length]);
        }
    };

    prevImage = () => {
        if (!!imageToShow) {
            const index = allExpandableImages.indexOf(imageToShow);
            setImage(allExpandableImages[(index + allExpandableImages.length - 1) % allExpandableImages.length]);
        }
    };

    clearImage = () => setImage(undefined);

    return (
      <div>
        <div className={"modal-" + !!imageToShow}>
            <div className="backdrop" onClick={() => setImage(undefined)}></div>
            <img className="image-displayer" src={imageToShow} />
        </div>
        <div className="maincontent">
            <div className="header-bar-small">
                <div className="name-title light">
                    <h1 onClick={() => changePage("main")}>Christina Winchester</h1>
                </div>
                <div className="button-bar-small">
                    <Button changePage={changePage} pageName="character" innerClassName="btn-smaller" containerClassName="character-btn-container" buttonFile={require('./images/buttonc.svg')} caption="Character Design"/>
                    <Button changePage={changePage} pageName="animation" innerClassName="btn-small" containerClassName="animation-btn-container" buttonFile={require('./images/buttona.svg')} caption="Animation"/>
                    <Button changePage={changePage} pageName="graphic" innerClassName="btn-small" containerClassName="graphic-btn-container" buttonFile={require('./images/buttong.svg')} caption="Graphic Design"/>
                    <Button changePage={changePage} pageName="uxui" innerClassName="btn-smaller" containerClassName="uxui-btn-container" buttonFile={require('./images/buttonu.svg')} caption="UX/UI Design"/>
                </div>
            </div>
            <div className="uxui-heading-section">
                <div>
                    <img className="uxui-btn-1 clickable" src={require('./images/uxuidesign/buttons/uib1.png')} onClick={() => setImage(image1)} />
                </div>
                <div className="uxui-heading-subsection">
                    <div className="uxui-heading darker">
                        <h1>UX / UI Design</h1>
                    </div>
                    <div className="heading-bar-right">
                        <img src={require('./images/uxuidesign/bu2.jpg')}/>
                    </div>
                    <div className="uxuidesign-description medium">
                        <p>UX and UI design are the newest skillset I have picked up. My degree included the study of UI design, so it made sense for me to dip my hands in it as well!</p>
                        <p>Please feel free to throw a design challenge at me. I'd love nothing more than to prove my mettle!</p>
                    </div>
                </div>
            </div>
            <div className="lionheart-section light">
                <div className="lionheart-section-text">
                    <div className="lionheart-section-text-header">
                        <h2>Lionheart Photography Company</h2>
                    </div>
                    <div className="lionheart-section-text-paragraph">
                        <p>The Lionheart Photography Company commissioned me to create their company logo and website. I primarily worked on the coding and base design for the site, though all photos were chosen by the owner.</p>
                        <p>(Lionheart Photography's website is indefinitely offline.)</p>
                    </div>
                </div>
                <img className="uxui-btn-2 clickable" src={require('./images/uxuidesign/buttons/uib2.png')} onClick={() => setImage(image2)} />
            </div>
            <div className="mainrouge-section">
                <div className="mainrouge-section-left-pane">
                    <div className="imagepair">
                        <img className="uxui-btn-3 clickable" src={require('./images/uxuidesign/buttons/uib3.png')} onClick={() => setImage(image3)} />
                        <img className="uxui-btn-4 clickable" src={require('./images/uxuidesign/buttons/uib4.png')} onClick={() => setImage(image4)} />
                    </div>
                    <div className="imagepair">
                        <img className="uxui-btn-5 clickable" src={require('./images/uxuidesign/buttons/uib5.png')} onClick={() => setImage(image5)} />
                        <img className="uxui-btn-6 clickable" src={require('./images/uxuidesign/buttons/uib6.png')} onClick={() => setImage(image6)} />
                    </div>
                </div>
                <div className="mainrouge-section-right-pane">
                    <div className="mainrouge-section-heading darker">
                        <h2>Mainrouge Research &amp; Privateer</h2>
                    </div>
                    <div className="mainrouge-section-description medium">
                        <p>Mainrouge Research is a B2B social media research company whose product, Privateer, is a full suite database.</p>
                        <p>I was tasked with building the look and feel of Privateer. The process involved putting together layouts, a style guide, and working with the programmer to turn it into a viable tool for them to use.</p>
                        <p>In addition to this, I developed all of their assets (including their primary MR logo) and designed their brochure.</p>
                    </div>
                </div>
            </div>
            <div className="thermostat-section centered-full">
                <div className="thermostat-section-heading darker">
                    <h2>Thermostat Challenge</h2>
                </div>
                <div className="thermostat-section-body">
                    <img className="uxui-btn-7 clickable" src={require('./images/uxuidesign/buttons/uib7.png')} onClick={() => setImage(image7)} />
                    <img className="uxui-btn-8 clickable" src={require('./images/uxuidesign/buttons/uib8.png')} onClick={() => setImage(image8)} />
                    <img className="uxui-btn-9 clickable" src={require('./images/uxuidesign/buttons/uib9.png')} onClick={() => setImage(image9)} />
                    <div className="thermostat-section-description light">
                        This was a challenge I was issued by my UX mentor to develop a design for a thermostat. It went through a few revisions before ending up with this final version.
                    </div>
                </div>
            </div>
            <img src={require('./images/animation/ba4.jpg')} />
            <div className="copyright-info">
                © Christina Winchester; 2019
            </div>
        </div>
      </div>
    );
  }
}

export default UXUIPage;
